import { Icon } from "@iconify/react/dist/iconify.js";
import { storeId } from "../data/constants";
import { useSelector } from "react-redux";
import { getStores } from "../redux/selectors";

export const UpdatesBanner = () => {
  const stores = useSelector(getStores);
  const { notice, enableNotice } = stores.find((s) => s._id === storeId);

  if (!enableNotice || !notice.length) return null;

  return (
    <div className="relative w-full h-14 lg:h-16 bg-red-600 text-mainWhite uppercase font-extrabold">
      <Icon
        icon="fxemoji:loudspeaker"
        className="absolute left-2 lg:left-20 top-1/4 text-2xl lg:text-3xl animate-pulse"
      />
      {notice.map((text, index) => (
        <h2
          key={index}
          className={`absolute left-10 right-10 lg:mt-4 text-xl drop-shadow-xl opacity-0 lg:text-3xl animate-rotate-words-${
            index + 1
          }`}
        >
          {text}
        </h2>
      ))}
      <Icon
        icon="fxemoji:loudspeaker"
        className="absolute right-2 lg:right-20 top-1/4 text-2xl lg:text-3xl animate-pulse [transform:_rotateY(180deg)] "
      />
    </div>
  );
};
